import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {pythonScriptActions} from "../../slice/efe/pythonScriptSlice";
import {
    CodeListResponse,
    EventListResponse,
    ScriptResponse,
    VariablesListResponse
} from "../../data/pythonScript";

export const getCodeList = (): any => {
    return async (dispatch: any) => {
        dispatch(pythonScriptActions.setLoading(true));

        Axios.get(`/efe/python-script/code/list`)
            .then((res: AxiosResponse<CodeListResponse>) => {
                dispatch(pythonScriptActions.setCodeList(res.data.codeList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(pythonScriptActions.setError(resp));
                    }
                }
            });
    };
};

export const getScript = (codeTag: string): any => {
    return async (dispatch: any) => {
        dispatch(pythonScriptActions.setLoading(true));

        Axios.get(`/efe/python-script/script/list/${codeTag}`)
            .then((res: AxiosResponse<ScriptResponse>) => {
                dispatch(pythonScriptActions.setScriptList(res.data.script));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(pythonScriptActions.setError(resp));
                    }
                }
            });
    };
};

export const getVariablesList = (codeTag: string): any => {
    return async (dispatch: any) => {
        dispatch(pythonScriptActions.setLoading(true));

        Axios.get(`/efe/python-script/variables/list/${codeTag}`)
            .then((res: AxiosResponse<VariablesListResponse>) => {
                dispatch(pythonScriptActions.setVariablesList(res.data.variablesList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(pythonScriptActions.setError(resp));
                    }
                }
            });
    };
};

export const getEventList = (codeTag: string): any => {
    return async (dispatch: any) => {
        dispatch(pythonScriptActions.setLoading(true));

        Axios.get(`/efe/python-script/event/list/${codeTag}`)
            .then((res: AxiosResponse<EventListResponse>) => {
                dispatch(pythonScriptActions.setEventList(res.data.eventList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(pythonScriptActions.setError(resp));
                    }
                }
            });
    };
};